import { createContext, useContext, useMemo, useState } from 'react';
import type { Dispatch, SetStateAction, ReactNode } from 'react'

import { Data, PartnerData, UserData } from '../types/Data';

interface ContextData {
	data: {
		quizData: Data
		doubleBed: boolean
	}
	setData: Dispatch<SetStateAction<ContextData['data']>>
}

const Context = createContext({} as ContextData);

export const DEFAULT_DATA: Data = {
    you: {
        height: 180,
        weight: 85,
        gender: 'Mann',
        sleepPosition: 'auf der Seite',
        body: 'normal',
        tendencies: [],
        tossAndTurn: 'manchmal',
        ownFirmness: 'eher weiches Liegegefühl',

        firmness: '',
        score: 0,
        bmi: 0,
    },
    partner: {
        height: 170,
        weight: 65,
        gender: 'Frau',
        sleepPosition: 'auf der Seite',
        body: 'normal',
        tendencies: [],
        tossAndTurn: 'manchmal',
        ownFirmness: 'eher weiches Liegegefühl',

        firmness: '',
        score: 0,
        bmi: 0,

        changed: false,
    },
}

export default function QuizContext({ children }: { children: ReactNode }) {
	const [data, setData] = useState<ContextData['data']>({
		quizData: DEFAULT_DATA,
		doubleBed: true,
	} as ContextData['data']);
	const value = useMemo(() => ({ data, setData }), [data, setData]);
	
	return (
		<Context.Provider value={value}>
			{ children }
		</Context.Provider>
	);
}

export function useQuiz() {

	return useContext(Context);
}

export function useQuizData() {
	const { data, setData } = useQuiz();

	function setQuizData(tab: 'you' | 'partner', value: UserData | PartnerData) {
		
		setData((data) => ({
			...data,
			quizData: {
				...data.quizData,
				[tab]: value,
			},
		}));
	}

	return {
		quizData: data.quizData,
		setQuizData,
	};
}
